// Owner: scheduling (owner feedback F13). The `meeting-book` layer: "Book a meeting" for a person, a record
// or colleagues. Loads on first open (`features/scheduling/events.ts` opens it).
import { lazy } from 'react';
import { defineGlobalLayer } from '../shell/overlays';
import '../features/scheduling/events';

export default defineGlobalLayer({
  id: 'meeting-book',
  component: lazy(() => import('../features/scheduling/BookMeetingDialog')),
});
